import styles from './styles/main.module.css';

import JaasPeople from './JaasPeople';

const Home = () => {
    return (
        <>
            <main className={styles.main}>
                
                <div className={styles.projectDetails}>
                    <div className={styles.projectTitle}>
                        <h3 className={styles.projectTitle}>
                            About JAAS
                        </h3>
                    </div>
                    <div className={styles.projectDescription}>
                        <p className={styles.projectDescription}>
                            We are a software company focused on the development of modern day entreprise business applications and work tools.                            
                        </p>
                        <p className={styles.projectDescription}>                            
                            Our goal is to facilitate the future of work by providing the right tools for maximum performance.
                        </p>
                    </div>                    
                </div>

            </main>
            <div className={styles.portfolioEmail}>
                <a href="portfolio" className={styles.portfolio} id="portfolio">
                    <h3 className={styles.portfolioButton} id="portfolioButton">                        
                        Go To Portfolio                       
                    </h3>

                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 24H38" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M24 10L38 24L24 38" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
                {/* <div className={styles.projectsLink}>
                    <a href="mailto:hello@getjaas.com" className={styles.projectLink}>Email Us</a>
                </div> */}
            </div>           
            <JaasPeople />
        </>
    );
}

export default Home;